/**
 * https://docs.sentry.io/platforms/javascript/guides/react/session-replay/
 * https://docs.sentry.io/platforms/javascript/install/loader/
 * sentry 配置：https://sentry.baijia.com/settings/gaotu-web/projects/dis-taitan/keys/
 */
import * as Sentry from '@sentry/browser';

import {getProcessEnv} from '@/preview-components/utils';

const ENV = getProcessEnv();

Sentry.init({
    dsn: 'https://83c0d74eb9390defbba0eb53f79d0aa6@sentry.baijia.com/1340',
    environment: ENV === 'test' ? 'development' : 'production',
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
});
